module.exports = __webpack_public_path__ + "static/media/Lubricants_Animation_Types.3ae6fc5e.gif";